import { useEffect, useState } from 'react';

const RECAPTCHA_SCRIPT_ID = 'recaptcha-script';
const RECAPTCHA_SCRIPT_URL = 'https://www.google.com/recaptcha/api.js';

export const useReCaptchaLoader = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if script already exists
    const existingScript = document.getElementById(RECAPTCHA_SCRIPT_ID);
    
    if (existingScript) {
      setIsLoaded(true);
      return;
    }

    // Check if grecaptcha is already available (in case script loaded by other means)
    if (typeof window !== 'undefined' && (window as any).grecaptcha) {
      setIsLoaded(true);
      return;
    }

    // Load the script
    setIsLoading(true);
    const script = document.createElement('script');
    script.id = RECAPTCHA_SCRIPT_ID;
    script.src = RECAPTCHA_SCRIPT_URL;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      setIsLoaded(true);
      setIsLoading(false);
    };

    script.onerror = () => {
      setIsLoading(false);
      console.error('Failed to load reCAPTCHA script');
    };

    document.head.appendChild(script);

    return () => {
      // Cleanup if component unmounts before script loads
      if (script.parentNode && !isLoaded) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return { isLoaded, isLoading };
};
